window.documentFormatter = function(value, row) {
    let html = '';
    if (can('documents')) {
        html += '<a href="'+row.action_download+'">';
        html += value;
        html += '</a>';
    } else {
        html += value;
    }
    return html;
};
